import React, { useState, useEffect } from 'react';
import { Box, MenuItem, FormLabel, Grid2 } from '@mui/material';
import TextFieldInput from '../themes/overrides/TextFieldInput';
import PropTypes from 'prop-types';

const getTimeZones = () => {
    return Intl.supportedValuesOf("timeZone");
};

const DateTimeEntry = ({ name, onChange, value, formatEdit }) => {
    const [date, setDate] = useState("");
    const [time, setTime] = useState("");
    const [timeZone, setTimeZone] = useState(Intl.DateTimeFormat().resolvedOptions().timeZone);

    const timeZones = getTimeZones();

    useEffect(() => {
        if (value) {
            setDate(value.date || "");
            setTime(value.time || "");
            setTimeZone(value.timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone);
        }
    }, [value]);


    const handleChange = (newDate, newTime, newTimeZone) => {
        setDate(newDate);
        setTime(newTime);
        setTimeZone(newTimeZone);

        if (onChange) {
            onChange({
                date: newDate,
                time: newTime,
                timeZone: newTimeZone
            });
        }
    };

    return (
        <Box sx={{ width: '100%' }}>
            <FormLabel component="legend" sx={{ color: 'black', mb: 1 }}>{name}</FormLabel>
            <Grid2 container spacing={{ xs: 2, md: 4 }}>
                <Grid2 size={{ xs: 12, md: formatEdit ? 5 : 6 }}>
                    <TextFieldInput
                        fullWidth
                        type="date"
                        value={date}
                        onChange={(e) => handleChange(e.target.value, time, timeZone)}
                    />
                </Grid2>

                <Grid2 size={{ xs: 6, md: formatEdit ? 3 : 2 }}>
                    <TextFieldInput
                        fullWidth
                        type="time"
                        value={time}
                        onChange={(e) => handleChange(date, e.target.value, timeZone)}
                    />
                </Grid2>

                <Grid2 size={{ xs: 6, md: 4 }}>
                    <TextFieldInput
                        fullWidth
                        select
                        value={timeZone}
                        onChange={(e) => handleChange(date, time, e.target.value)}
                    >
                        {timeZones.map((zone) => (
                            <MenuItem key={zone} value={zone}>
                                {zone}
                            </MenuItem>
                        ))}
                    </TextFieldInput>
                </Grid2>
            </Grid2>
        </Box>
    );
};

DateTimeEntry.propTypes = {
    name: PropTypes.any,       
    onChange: PropTypes.func,         
    value: PropTypes.any,
};

export default DateTimeEntry;